module.exports = __webpack_public_path__ + "static/background-video-3.2-b94125f917f03f4fa87278d766d67e27.mp4";